import { render, staticRenderFns } from "./AiDiagnosis.vue?vue&type=template&id=047fc845&scoped=true"
import script from "./AiDiagnosis.vue?vue&type=script&lang=js"
export * from "./AiDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./AiDiagnosis.vue?vue&type=style&index=0&id=047fc845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047fc845",
  null
  
)

export default component.exports